/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DecimalNullableResponseModel } from '../../models/decimal-nullable-response-model';
import { VendorAuctionWorksheetTakeTheDealDto } from '../../models/vendor-auction-worksheet-take-the-deal-dto';

export interface ApiVendorVendorAuctionSubmitTakeTheDealBestBidToWinPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionWorksheetTakeTheDealDto
}

export function apiVendorVendorAuctionSubmitTakeTheDealBestBidToWinPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionSubmitTakeTheDealBestBidToWinPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DecimalNullableResponseModel>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionSubmitTakeTheDealBestBidToWinPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DecimalNullableResponseModel>;
    })
  );
}

apiVendorVendorAuctionSubmitTakeTheDealBestBidToWinPost.PATH = '/api/vendor/vendor-auction/SubmitTakeTheDealBestBidToWin';
